export default __webpack_public_path__ + "static/media/58_desktop.524cd859.jpg";